export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1440w.71704c59.png";